// LICENSE_CODE ZON
/*jslint browser:true, es6:true, node:true, react:true*/
import {notification_variant} from '../../../../../oculus/pub/ui/dashboard/notification_item';
import date from '/util/date.js';

export interface i_notification {
    _id: string;
    title: string;
    message: string;
    type: string;
    time: string;
    button_text?: string;
    button_link?: string;
    read: boolean;
    insert_ts: string;
    icon_url: string;
    variant: notification_variant;
    open_in_new_tab?: boolean;
    is_test?: boolean;
}
export interface i_notification_alert {
    _id: string;
    message: string;
    type: string;
    time: string;
    button_text?: string;
    button_link?: string;
    icon_url: string;
    variant: notification_variant;
    open_in_new_tab?: boolean;
    is_test?: boolean;
}
const MS_IN_DAY = date.ms.DAY;
const is_today = (d: Date)=>{
    const now = new Date();
    return date.align(d, 'DAY').getTime() === date.align(now, 'DAY').getTime();
};
const is_yesterday = (d: Date)=>{
    const now = new Date();
    const yesterday = new Date(now.getTime() - MS_IN_DAY);
    return date.align(d, 'DAY').getTime() ===
        date.align(yesterday, 'DAY').getTime();
};
export const format_notification_time = (ts: string): string=>{
    const d = new Date(ts);
    const time_str = d.toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
    });
    if (is_today(d))
        return time_str;
    if (is_yesterday(d))
        return `Yesterday | ${time_str}`;
    const date_str = d.toLocaleDateString([], {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
    });
    return `${date_str} | ${time_str}`;
};
export const group_notifications = (notifications: i_notification[])=>{
    const today: i_notification[] = [];
    const last_7_days: i_notification[] = [];
    const last_month: i_notification[] = [];
    const now = new Date();
    const seven_days_ago = new Date(now.getTime() - 7 * date.ms.DAY);
    notifications.forEach(n=>{
        const d = new Date(n.time);
        if (is_today(d))
            today.push(n);
        else if (d > seven_days_ago)
            last_7_days.push(n);
        else last_month.push(n);
    });
    return {today, last_7_days, last_month};
};
